import { atom } from "recoil";

const KEY = "new-thread-messages";

export const NewThreadMessagesAtom = atom<number[]>({
    key: KEY,
    default: [],
});
